export default __webpack_public_path__ + "static/media/promotion-amount-bg.a1e2a82b.png";